export default __webpack_public_path__ + "static/media/logoutArrow.cd63a7d2.jpg";